import {ACTION_UPDATE_USERNAME, ACTION_UPDATE_VERIFICATION_FLOW, ACTION_UPDATE_AADHAR_FLOW} from './UserVerificationActions';
import { RAILS_IRCTC_USERNAME } from 'apps/rails/src/Utils/RailsConstant';
import {
  getItemBySession,
  itemType
} from 'MMT-UI/storages/client/sessionStorage';

const initialState = {
  irctcUserName: JSON.parse(
    getItemBySession(
      RAILS_IRCTC_USERNAME,
      { shouldStringifyJson: true, isPiiData: true },
      itemType.ES
    )
  ),
  verificationFlow: {},
  aadharConfigKeyResponse: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_UPDATE_USERNAME: {
      let { irctcUserName } = action.data;
       if (!irctcUserName) {
         irctcUserName = JSON.parse(
           getItemBySession(
             RAILS_IRCTC_USERNAME,
             { shouldStringifyJson: true, isPiiData: true },
             itemType.ES
           )
         );
       }

      return {
        ...state,
        irctcUserName
      };
    }
    case ACTION_UPDATE_VERIFICATION_FLOW: {
      const {
        verificationFlow
      } = action.data;

      return {
        ...state,
        verificationFlow
      };
    }
    case ACTION_UPDATE_AADHAR_FLOW: {
      const {
        aadharConfigKeyResponse
      } = action.data;
      return {
        ...state,
        aadharConfigKeyResponse
      };
    }
    default: {
      return state;
    }
  }
};
